import { useLocation, useHistory } from 'react-router-dom'
import { getModalLocation } from '../lib/modal'

const useShowModal = () => {
  const location = useLocation()
  const history = useHistory()

  const showModal = (modalType, params) => {
    const modalLocation = getModalLocation(location, modalType, params)
    history.push(modalLocation)
  }

  return showModal
}

export default useShowModal
